// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_PatientsList_wrapper__tUbPZ"};